import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
    formControlAutoComplete: {
        minWidth: "100%",
        margin: "10px"
    },
    formControl: {
        minWidth: "100%",
        margin: "10px",
    },
    input: {
        padding: "5px",
    },
    // tableHeadline: {
    //     backgroundColor: theme.palette.primary.main,
    //     color: "white",
    //     padding: "10px"
    // },
    zeitraumSelect: {
        minWidth: "80%",
        padding: "5px",
        margin: "5px",
    },
    centerTypographyRoot: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center"
    },
    select: {
        color: "white",
    },
    icon: { color: "white" },
    label: { color: "white" },
    selectBorder: {
        "&:before": {
            borderColor: "white"
        }
    },
    highlightCell: { backgroundColor: "rgb(250, 250, 235)" }
}), { index: 1 });